import { render, staticRenderFns } from "./clasSelectBox.vue?vue&type=template&id=3b0d8c2e&scoped=true"
import script from "./clasSelectBox.vue?vue&type=script&lang=js"
export * from "./clasSelectBox.vue?vue&type=script&lang=js"
import style0 from "./clasSelectBox.vue?vue&type=style&index=0&id=3b0d8c2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d8c2e",
  null
  
)

export default component.exports